function __metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

if (typeof module !== 'undefined' && module.exports) {
    exports = module.exports = __metadata;
}

exports.__metadata = __metadata;


//////////////////
// WEBPACK FOOTER
// ./~/typescript-metadata/index.js
// module id = 25
// module chunks = 0